import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { workflowAPI } from '../../utils/crmApi';

const WorkflowEdit = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [workflow, setWorkflow] = useState(null);

    useEffect(() => {
        const load = async () => {
            try {
                setLoading(true);
                const res = await workflowAPI.getById(id);
                if (res.data?.success) {
                    setWorkflow(res.data.data);
                } else {
                    setError(res.data?.message || 'Failed to load workflow');
                }
            } catch (e) {
                setError(e.response?.data?.message || 'Failed to load workflow');
            } finally {
                setLoading(false);
            }
        };
        load();
    }, [id]);

    if (loading) {
        return (
            <div className="p-6">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
            </div>
        );
    }

    if (error) {
        return (
            <div className="p-6 text-red-600 text-sm">{error}</div>
        );
    }

    if (!workflow) {
        return (
            <div className="p-6 text-sm">Workflow not found.</div>
        );
    }

    return (
        <div className="p-6 space-y-4">
            <div className="flex items-center justify-between">
                <h1 className="text-xl font-semibold text-foreground">Edit Workflow</h1>
                <div className="flex items-center gap-2">
                    <Link to={`/workflows/${workflow._id}`} className="px-3 py-1.5 text-sm border rounded">View</Link>
                    <button onClick={() => navigate(-1)} className="px-3 py-1.5 text-sm border rounded">Back</button>
                </div>
            </div>

            <div className="bg-blue-50 border border-blue-200 text-blue-800 text-sm rounded p-3">
                A full edit UI is not implemented yet. For now, you can use the Visual Workflow Builder.
            </div>

            <div>
                <Link to={`/workflows/visual?id=${workflow._id}`} className="inline-block px-4 py-2 text-sm text-white rounded" style={{ backgroundColor: '#2563eb' }}>
                    Open Visual Workflow Builder
                </Link>
            </div>

            <div className="bg-card rounded-lg border border-border p-4">
                <div className="font-semibold text-foreground mb-2">Current Workflow Data</div>
                <pre className="text-xs bg-muted p-3 rounded overflow-auto text-foreground">{JSON.stringify(workflow, null, 2)}</pre>
            </div>
        </div>
    );
};

export default WorkflowEdit;


